<template>
    <div style="width: 100%;">
      <div class="personal_left">
        <ul>
          <li><a v-if="isLogin&&applyNum>0 && isLegal=='0'" href="javascript:void(0)" :class="getClass('cardMaking')" @click="()=>{this.$router.push({path:'personal_cardMaking'});}"><span style="line-height: 30px;"> <el-badge :max="99"  :value="applyNum" class="item"  >我的办件</el-badge></span></a></li>
          <li><a v-if="isLogin&&applyNum==0 && isLegal=='0'" href="javascript:void(0)" :class="getClass('cardMaking')" @click="()=>{this.$router.push({path:'personal_cardMaking'});}"><span style="line-height: 30px;">我的办件</span></a></li>
          <li><a href="javascript:void(0)" :class="getClass('marriage')" @click="()=>{this.$router.push({path:'personal_marriage'});}">我的预约</a></li>
          <li><a href="javascript:void(0)" :class="getClass('evaluation')" @click="()=>{this.$router.push({path:'personal_evaluation'});}">我的评价</a></li>
          <li><a href="javascript:void(0)" :class="getClass('consulting')" @click="()=>{this.$router.push({path:'personal_consulting',query:{type:4}});}">我的咨询</a></li>
          <li><a href="javascript:void(0)" :class="getClass('suggestion')" @click="()=>{this.$router.push({path:'personal_suggestion',query:{type:2}});}">我的建议</a></li>
          <li><a href="javascript:void(0)" :class="getClass('complaint')" @click="()=>{this.$router.push({path:'personal_complaint',query:{type:1}});}">我的投诉</a></li>

          <!--<li><a  href="javascript:void(0)" :class="getClass('ylNeedCardMaking')" @click="()=>{this.$router.push({path:'ylNeed_cardMaking'});}"><span style="line-height: 30px;">需求评估</span></a></li>-->
   <!--       <li><a href="javascript:void(0)" :class="getClass('magicCardMaking')" @click="()=>{this.$router.push({path:'personal_magicCardMaking'});}"><span style="line-height: 30px;">法人办件</span></a></li>-->
          <!--<li><a href="javascript:void(0)" :class="getClass('appointment')" @click="()=>{this.$router.push({path:'personal_appointment'});}">我的预约</a></li>-->
          <li v-if="isLogin  && isLegal=='0'"><a href="javascript:void(0)" :class="getClass('enjoyTreat')" @click="()=>{this.$router.push({path:'personal_enjoyTreat'});}">我的待遇</a></li>
      <!--    <li v-if="isLogin  && isLegal=='0'"><a href="javascript:void(0)" :class="getClass('relationship')" @click="()=>{this.$router.push({path:'relationshipSet'});}">关系设置</a></li>-->
          <li v-if="isLogin&&msgNum>0"><a href="javascript:void(0)" :class="getClass('message')" @click="()=>{this.$router.push({path:'personal_message'});}"><span style="line-height: 30px;"><el-badge is-dot class="item"  >消息中心</el-badge></span></a></li>
          <li v-if="isLogin&&msgNum==0"><a href="javascript:void(0)" :class="getClass('message')" @click="()=>{this.$router.push({path:'personal_message'});}">消息中心</a></li>
          <li v-if="isLogin"><a href="javascript:void(0)" :class="getClass('security')" @click="()=>{this.$router.push({path:'personal_security'});}">修改密码</a></li>
          <li v-if="isLogin && isLegal=='0'"><a href="javascript:void(0)" :class="getClass('certification')"  @click="()=>{this.$router.push({path:'peopleCertification'});}">实名认证</a></li>
          <li v-if="isLogin && isLegal=='1'"><a href="javascript:void(0)" :class="getClass('certification')"  @click="()=>{this.$router.push({path:'legalCertification'});}">法人认证</a></li>
          <li v-if="isLogin"><a href="javascript:void(0)" :class="getClass('personalinfo')" @click="()=>{this.$router.push({path:'personal_personalInfo'});}">个人信息</a></li>
          <li v-if="isLogin"><a href="javascript:void(0)" :class="getClass('deregister')" @click="()=>{this.$router.push({path:'deregister'});}">账户注销</a></li>
        </ul>
      </div>
    </div>
</template>

<script>
  export default {
    name: "fixedDiv",
    props:{
      pageType: {
        type: String,
        default: 'cardMaking',
      },
    },
    components:{
    },
    data(){
      return{
        msgNum:0,
        applyNum:0,
        isLogin:false,
        isLegal:'0',
      }
    },
    created(){
      var userInfo=this.$cookies.get('userInfo')
      if(userInfo && userInfo.userId !='' && userInfo.userId !=-1){
        this.isLogin=true;
        this.isLegal=this.$cookies.get('isLegal')
        this.getNoRead();
        this.getNoSubmit();
      }
    },
    methods:{
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
      getClass(t){
        if(t==this.pageType){
          return "per_on";
        }else{
          return "";
        }
      },
      getNoSubmit(){
        this.$https.post("api/apply/getNoSubmit.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data && response.data.data!=0){
              this.applyNum=response.data.data;
            }
          }
        });
      },
      getNoRead() {
        this.$https.post("api/msg/getMsgNum.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data && response.data.data!=0){
              this.msgNum=response.data.data;
            }
          }
        });
      },
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Personal.vue